import { fromJS } from 'immutable';
import { get, reverse, sortBy } from 'lodash';

export const types = {
  REPORT_REQUEST: 'REPORTS_REWASHES/REPORT_REQUEST',
  REPORT_SUCCESS: 'REPORTS_REWASHES/REPORT_SUCCESS',
  REPORT_FAILURE: 'REPORTS_REWASHES/REPORT_FAILURE',
  RESET: 'REPORTS_REWASHES/RESET',
};

const initialState = fromJS({
  isInitial: true,
  isFetching: false,
  requestDate: null,
  report: null,
});

function prepareReport(report) {
  if (get(report, 'empty', true)) {
    return null;
  }

  const mapped = report.rows.map(({ row }) => {
    return {
      rewashCount: row.rewashCount,
      firstTime: row.firstTime,
      lastTime: row.lastTime,
      licensePlate: row.licensePlate,
      make: row.make,
      color: row.color,
    };
  });
  return reverse(sortBy(mapped, 'enterTime'));
}

export default function rewashes(state = initialState, action) {
  switch (action.type) {
    case types.REPORT_REQUEST:
      return state.withMutations(s => {
        const { requestDate } = action;
        s.set('report', null);
        s.set('requestDate', requestDate);
        s.set('isFetching', true);
        s.set('isInitial', false);
      });
    case types.REPORT_SUCCESS:
      return state.withMutations(s => {
        const { requestDate, report } = action;
        const { total, details } = report;
        s.set('isFetching', false);
        s.set('requestDate', requestDate);
        s.set('report', fromJS({ total, details: prepareReport(details) }));
        s.set('isInitial', false);
      });
    case types.REPORT_FAILURE:
      return state.withMutations(s => {
        s.set('isFetching', false);
        s.set('report', null);
        s.set('isInitial', false);
      });
    case types.RESET:
      return initialState;
    default:
      return state;
  }
}

export const actions = {
  reportRequest: (requestDate, timezone, period, location) => ({
    type: types.REPORT_REQUEST,
    requestDate,
    timezone,
    period,
    location,
  }),
  reportSuccess: (requestDate, timezone, period, location, report) => ({
    type: types.REPORT_SUCCESS,
    requestDate,
    timezone,
    period,
    location,
    report,
  }),
  reportFailure: (requestDate, timezone, period, location, error) => ({
    type: types.REPORT_FAILURE,
    requestDate,
    timezone,
    period,
    location,
    error,
  }),
  reset: () => ({ type: types.RESET }),
};

export const getRoot = state => state.get('reports').get('rewashes');
export const getRequestDate = state => getRoot(state).get('requestDate');
export const getReport = state => getRoot(state).get('report');
export const isReportFetching = state => getRoot(state).get('isFetching');
export const isReportInitial = state => getRoot(state).get('isInitial');
